import { Link } from 'react-router-dom';
import { AUDIT_RETENTION_DAYS } from '@/lib/utils';
import { useT } from '@/lib/i18n';

/**
 * Consentement obligatoire avant toute collecte : « Créer mon audit », dépôt
 * manuel d'un zip et ouverture d'une campagne partagent la MÊME case et le
 * même texte — `createAudit` comme `createCampaign` exigent `consent: true`
 * (sinon FAILED_PRECONDITION `consent_required`).
 */
export function ConsentCheckbox({ checked, onChange, disabled }: {
  checked: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
}) {
  const { t } = useT();
  return (
    <label className="mt-3 flex cursor-pointer items-start gap-2 rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-ink-700 dark:border-ink-700 dark:bg-ink-900/40 dark:text-ink-200">
      <input
        type="checkbox"
        data-testid="consent-checkbox"
        className="mt-0.5 h-4 w-4 shrink-0 accent-brand-600"
        checked={checked}
        disabled={disabled}
        onChange={e => onChange(e.target.checked)}
        aria-required
      />
      <span>
        {t('upload.consent.label', { N: AUDIT_RETENTION_DAYS })}{' '}
        <Link
          to="/help#data-collected"
          className="font-medium text-brand-600 underline decoration-brand-300 underline-offset-2 hover:text-brand-700 dark:text-brand-300"
          onClick={e => e.stopPropagation()}
        >
          {t('upload.consent.link')}
        </Link>
      </span>
    </label>
  );
}
